import React, { Fragment, useState } from "react";
import {
  PlusCircleIcon,
  XMarkIcon,
  AdjustmentsVerticalIcon
} from "@heroicons/react/24/outline";
import Logo from "../../../../images/logo.png";
import { Link } from "react-router-dom";
import { Dialog, Transition } from "@headlessui/react";
import IconButton from "../../../iconButton";

const AdminEmailSlideOver = ({ show, setShowSlide, handleClose, type }) => {
    const [quillContentMobile, setQuillContentMobile] = useState("");
  const [value, setValue] = useState({
    startDate: null,
    endDate: null,
  });
  const handleValueChange = (newValue) => {
    setValue(newValue);
  };
  return (
    <Transition.Root show={show} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden dashboard_calander_slideover">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full px-[15px] py-5 md:p-0">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-[478px]">
                  <div className="flex h-full flex-col bg-white py-5 md:pt-10 md:pb-5 px-4 md:px-8 shadow-xl rounded-md md:rounded-0">
                    <div className="border-b border-solid border-[#CCD0D4] pb-3 md:pb-[30px] mb-4 md:mb-6">
                      <div className="flex items-center justify-between mb-2 md:mb-5">
                        <Dialog.Title className="text-xl md:text-2xl font-bold leading-[160%] text-[#04091E] capitalize">
                          view template
                        </Dialog.Title>
                        <XMarkIcon
                          className="w-6 h-6 cursor-pointer text-black hover:text-red-700"
                          onClick={handleClose}
                        />
                      </div>
                    </div>
                    <div className="w-full h-full bg-white preview-template border-b border-solid border-[#EBEFF3] mb-[30px] scroller max-h-[640px] overflow-y-auto pr-1">
                      <div className="border-b border-solid border-[#EBEFF3] text-center pb-6 mb-[30px]">
                        <Link to="/">
                          <img src={Logo} alt="" className="h-[34px]" />
                        </Link>
                      </div>
                      <div
                        id="test"
                        dangerouslySetInnerHTML={{ __html: quillContentMobile }}
                      />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 md:gap-5">
                      <IconButton
                        title="edit template"
                        icon={AdjustmentsVerticalIcon}
                        classes={`mb-[14px] md:mb-0 flex items-center bg-white text-sm md:text-base rounded-[10px] text-primary border border-primary font-black uppercase leading-[160%] h-10 md:h-[58px] w-full justify-center cursor-pointer`}
                        // onClick={handleClose}
                        iconClasses="icon w-6 h-6 -ml-0.5 mr-[10px]"
                      />
                      <IconButton
                        title="delete"
                        icon={XMarkIcon}
                        classes={`mb-[14px] md:mb-0 flex items-center bg-white text-sm md:text-base rounded-[10px] text-[#EF2121] border border-b border-[#EF2121] font-black uppercase leading-[160%] h-10 md:h-[58px] w-full justify-center cursor-pointer`}
                        // onClick={handleClose}
                        iconClasses="icon w-6 h-6 -ml-0.5 mr-[10px]"
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default AdminEmailSlideOver;
